import { REQUEST_PATH } from './constants';
import { getHost } from './endpoints';
import { httpClient } from './http-client';

type TokenResponse = {
  token: string;
  endpoint: string;
  endpoints: { analytics: string; monolith: string };
};

export const getToken = async (organizationId: string) => {
  const response = await httpClient.post<TokenResponse>(
    getHost() + REQUEST_PATH.ANALYTICS_AUTH_TOKEN,
    {
      organization_external_id: organizationId,
      scope: 'org_analytics',
    },
    {
      withCredentials: true,
    },
  );
  return response.data;
};
